<template>
  <div>
    <Mixed />
    <GMV />
    <Crops />
  </div>
</template>

<script>
  import Mixed from '@/components/fusioncharts/Mixed';
  import GMV from '@/components/fusioncharts/GMV';
  import Crops from '@/components/fusioncharts/Crops';

  export default {
    components: {
      Mixed,
      GMV,
      Crops
    }
  }
</script>

<style scoped>

</style>